import { render, staticRenderFns } from "./fuhe.vue?vue&type=template&id=a6104880&scoped=true&"
import script from "./fuhe.vue?vue&type=script&lang=js&"
export * from "./fuhe.vue?vue&type=script&lang=js&"
import style0 from "./fuhe.vue?vue&type=style&index=0&id=a6104880&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6104880",
  null
  
)

export default component.exports